import React from 'react';
import SendMail from '../SendMail/Pages/SendMail';
import SendMailPage from '../SendMail/Pages/SendMailPage';
import UserSendsPage from './ProfilesUser/Pages/UserSendsPage';
import UserSendsHistory from './ProfilesUser/Pages/UserSendsHistory';
import Profiles from './ProfilesAdmin/Pages/Profiles';
import Users from './ProfilesAdmin/Pages/Users';
import History from './ProfilesAdmin/Pages/History';
import CreateSendsPage from './ProfilesAdmin/Pages/CreateSendsPage';
import EditSendsPage from './ProfilesAdmin/Pages/EditSendsPage';
import { SuggestibleRouteInterface } from '../_Global/Types/RouteTypes';

const StandaloneSendsUsersRoutes: Array<SuggestibleRouteInterface> = [
	{
		title: 'SendsAdmin Pages',
		path: '/sends-page',
		element: <UserSendsPage />,
	},
	{
		title: 'SendsAdmin Page',
		path: '/sends-page/:pageId',
		element: <UserSendsPage />,
	},
	{
		title: 'SendsAdmin Page History',
		path: '/sends-page/history',
		element: <UserSendsHistory />,
	},
];

const StandaloneSendsAdminUsersRoutes: any = [
	{
		title: 'Send Mail',
		path: '/send-mail/send',
		element: <SendMailPage />,
	},
	{
		title: 'Sends',
		path: '/send-mail/sends',
		element: <SendMail />,
	},
	{
		title: 'SendsAdmin Admin Pages',
		path: '/send-mail/pages',
		element: <Profiles />,
	},
	{
		title: 'SendsAdmin Admin History',
		path: '/send-mail/history',
		element: <History />,
	},
	{
		title: 'SendsAdmin Admin Users',
		path: '/send-mail/users',
		element: <Users />,
	},
	{
		title: 'SendsAdmin Admin Create',
		path: '/send-mail/create',
		element: <CreateSendsPage />,
	},
	{
		title: 'SendsAdmin Admin Edit',
		path: '/send-mail/edit/:pageId',
		element: <EditSendsPage />,
	},
];

export { StandaloneSendsUsersRoutes, StandaloneSendsAdminUsersRoutes };
